"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _energyRatingModule = _interopRequireDefault(require("./energy-rating.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var energyRatingImageFilenames = [{
  assetFilename: 'A.svg',
  hashedAssetFilename: 'A.d0fb5589.svg'
}, {
  assetFilename: 'B.svg',
  hashedAssetFilename: 'B.62c41d3c.svg'
}, {
  assetFilename: 'C.svg',
  hashedAssetFilename: 'C.83a078dd.svg'
}, {
  assetFilename: 'D.svg',
  hashedAssetFilename: 'D.4070790c.svg'
}, {
  assetFilename: 'E.svg',
  hashedAssetFilename: 'E.1654dc64.svg'
}, {
  assetFilename: 'F.svg',
  hashedAssetFilename: 'F.327ae98d.svg'
}, {
  assetFilename: 'G.svg',
  hashedAssetFilename: 'G.a24a9165.svg'
}];
var energyRatingLegacyImageFilenames = [{
  assetFilename: 'A+++.svg',
  hashedAssetFilename: 'A+++.0912f020.svg'
}, {
  assetFilename: 'A++.svg',
  hashedAssetFilename: 'A++.56180987.svg'
}, {
  assetFilename: 'A+.svg',
  hashedAssetFilename: 'A+.e2227015.svg'
}, {
  assetFilename: 'A.svg',
  hashedAssetFilename: 'A.9840c66e.svg'
}, {
  assetFilename: 'B.svg',
  hashedAssetFilename: 'B.3f468c94.svg'
}, {
  assetFilename: 'C.svg',
  hashedAssetFilename: 'C.7afd2f39.svg'
}, {
  assetFilename: 'D.svg',
  hashedAssetFilename: 'D.d9f887af.svg'
}];
function getHashedFilename(_ref) {
  var rating = _ref.rating,
    ratingLegacy = _ref.ratingLegacy;
  var asset = rating ? energyRatingImageFilenames.find(function (_ref2) {
    var assetFilename = _ref2.assetFilename;
    return "".concat(rating, ".svg") === assetFilename;
  }) : energyRatingLegacyImageFilenames.find(function (_ref3) {
    var assetFilename = _ref3.assetFilename;
    return "".concat(ratingLegacy, ".svg") === assetFilename;
  });
  return (asset === null || asset === void 0 ? void 0 : asset.hashedAssetFilename) || name;
}
var ENERGY_RATING_ASSETS_URL = 'https://www.johnlewis.com/static/ui-assets/hashed/images/energy-ratings/';
var EnergyRating = function EnergyRating(_ref4) {
  var _ref4$rating = _ref4.rating,
    rating = _ref4$rating === void 0 ? undefined : _ref4$rating,
    _ref4$ratingLegacy = _ref4.ratingLegacy,
    ratingLegacy = _ref4$ratingLegacy === void 0 ? undefined : _ref4$ratingLegacy,
    _ref4$className = _ref4.className,
    className = _ref4$className === void 0 ? '' : _ref4$className,
    _ref4$hasEnergySideDr = _ref4.hasEnergySideDrawer,
    hasEnergySideDrawer = _ref4$hasEnergySideDr === void 0 ? false : _ref4$hasEnergySideDr,
    _ref4$handleEnergyRat = _ref4.handleEnergyRatingClick,
    handleEnergyRatingClick = _ref4$handleEnergyRat === void 0 ? function () {} : _ref4$handleEnergyRat;
  var availableRating = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
  var availableRatingLegacy = ['A+++', 'A++', 'A+', 'A', 'B', 'C', 'D'];
  if ((!rating || !availableRating.includes(rating)) && (!ratingLegacy || !availableRatingLegacy.includes(ratingLegacy))) {
    return null;
  }
  var imageUrlSuffix = rating ? '' : 'legacy/';
  var imagePath = "".concat(ENERGY_RATING_ASSETS_URL).concat(imageUrlSuffix).concat(getHashedFilename({
    rating: rating,
    ratingLegacy: ratingLegacy
  }));
  var altTextShort = rating ? "Energy efficiency rating ".concat(rating, " on a scale of A to G") : "Energy efficiency rating ".concat(ratingLegacy, " on a scale of A+++ to D");
  var altTextLong = rating ? "This item is rated ".concat(rating, " for energy efficiency on a scale of A most efficient to G least efficient") : "This item is rated ".concat(ratingLegacy, " for energy efficiency on a scale of A+++ most efficient to D least efficient");
  var energyRating = rating ? rating : ratingLegacy;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames["default"])(_energyRatingModule["default"]['energy-rating'], className),
    children: hasEnergySideDrawer ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      onClick: function onClick() {
        return handleEnergyRatingClick(altTextLong, energyRating);
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        "data-testid": "energy-rating",
        title: altTextShort,
        alt: altTextShort,
        src: imagePath
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      "data-testid": "energy-rating",
      title: altTextShort,
      alt: altTextShort,
      src: imagePath
    })
  });
};
EnergyRating.propTypes = {
  rating: _propTypes["default"].string,
  ratingLegacy: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(EnergyRating);